import { Box } from '@mui/material'
import { ReactNode, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { GatewayDevice } from '../../lib/types'
import { customerELEP } from '../../lib/utils'
import { RootState } from '../../redux/deviceStatistics/types'
import FooterSection from './FooterSection'
import HeaderSection from './HeaderSection'

type AnimatedLayoutProps = {
  children: ReactNode
  gatewayInfo?: GatewayDevice
}

const AnimatedLayout = ({ children, gatewayInfo }: AnimatedLayoutProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const defaultUserData = useSelector((state: RootState) => state.user)

  useEffect(() => {
    if (defaultUserData?.scrollTriggerAt) {
      containerRef.current?.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }, [defaultUserData?.scrollTriggerAt])

  return (
    <div className='anmated-layout-wrapper relative'>
      <HeaderSection gatewayInfo={gatewayInfo} />
      <Box
        ref={containerRef}
        sx={
          process.env.REACT_APP_MODE !== 'local' || customerELEP
            ? {
                height: customerELEP ? 'calc(100vh - 180px)' : 'calc(100vh - 206px)',
                display: 'block',
                overflowY: 'scroll'
              }
            : {
                display: 'unset',
                overflowY: 'unset'
              }
        }
      >
        {children}
      </Box>
      {<FooterSection />}
      {/* {process.env.REACT_APP_MODE !== 'local' && <FooterSection />} */}
    </div>
  )
}

export default AnimatedLayout
